exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Mixins\n */\n.new-user .mat-input-infix {\n  border-top-width: 0px;\n  padding-bottom: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/users/new-user/new-user.component.scss
// module id = ../../../../../src-admin/app/components/users/new-user/new-user.component.scss
// module chunks = main